export default "__VITE_ASSET__DaJG7ey6__"